import { jsx as _jsx } from "react/jsx-runtime";
const STATE_LABEL_DEFAULTS = {
    granted: 'Authority granted',
    denied: 'Authority denied',
    revoked: 'Authority revoked',
    pending: 'Authority pending',
};
export function AuthorityIndicator(props) {
    const label = props.label ?? STATE_LABEL_DEFAULTS[props.state];
    return (_jsx("span", { className: `shn-authority-indicator shn-authority-indicator--${props.state}`, role: "status", "data-testid": `authority-indicator-${props.state}`, children: label }));
}
//# sourceMappingURL=authority-indicator.js.map